import React from 'react';
import { Link } from 'react-router';
import type { Candidate } from '@axiom/validation';
import {
  Banner,
  DateUtil,
  Gutter,
  IconButton,
  Layout,
  LayoutItem,
  ParagraphHeader,
} from '@axiom/ui';

import { CandidateApi } from '../../api/candidate-api';

export type ProfileHeaderProfileImageBannerProps = {
  candidate: Candidate;
  dismissible?: boolean;
  name?: string;
  onAdd?: () => void;
};

export const ProfileHeaderProfileImageBanner: React.FC<
  ProfileHeaderProfileImageBannerProps
> = ({
  candidate,
  dismissible = false,
  name = 'PROFILE_HEADER_SUGGEST_PHOTO_HINT',
  onAdd,
}) => {
  return !candidate.profileImageKey && !candidate.suggestPhotoDismissedAt ? (
    <Gutter bottom="16px">
      <Banner impact="low" type="info" name={name}>
        <Layout>
          <LayoutItem>
            <ParagraphHeader as="span">
              Personalize your profile.
            </ParagraphHeader>{' '}
            A professional profile photo is not required but has been shown to
            increase client response rates.{' '}
            {onAdd ? (
              <Link
                to="#"
                onClick={() => {
                  onAdd();
                }}
                data-test="PROFILE_HEADER_SUGGEST_PHOTO_HINT_EDIT"
              >
                Add a profile photo now.
              </Link>
            ) : null}
          </LayoutItem>
          {dismissible ? (
            <LayoutItem>
              <IconButton
                icon="x-mark"
                name="PROFILE_HEADER_SUGGEST_PHOTO_HINT_DISMISS"
                onClick={async () => {
                  await CandidateApi.updateCandidate(candidate.id, {
                    suggestPhotoDismissedAt: DateUtil.formatAsTimestamp(
                      new Date()
                    ),
                  });
                  await CandidateApi.refreshCandidate(candidate.id);
                }}
                pattern="secondary"
                variation="minimal"
              />
            </LayoutItem>
          ) : null}
        </Layout>
      </Banner>
    </Gutter>
  ) : null;
};
